import { render, staticRenderFns } from "./trendsList.vue?vue&type=template&id=48ddb23f&scoped=true"
import script from "./trendsList.vue?vue&type=script&lang=js"
export * from "./trendsList.vue?vue&type=script&lang=js"
import style0 from "./trendsList.vue?vue&type=style&index=0&id=48ddb23f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddb23f",
  null
  
)

export default component.exports